import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ErrorIcon from '@mui/icons-material/Error';
import { Button, Stack } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichPaper } from 'src/components/ui-component/mein-bereich/MeinBereichComponents';
import { PAGES_URLS } from 'src/lib/constants/routes';

// import Schemas
import Schema from 'src/lib/paths/organisation_FULL_Paths.json';
import { isTrue } from 'src/utils/helper';
const P = Schema.attributes;

const RegisrierungAbschliessen: FC<{ orgaDetails: any }> = ({ orgaDetails }) => {
	const navigate = useNavigate();

	const showBankdatenButton = useMemo(() => {
		const bankdaten = get(orgaDetails, P.Bankdaten.path, []);

		// Wenn keine Bankdaten vorhanden sind, Button anzeigen
		if (bankdaten.length === 0) {
			return true;
		}

		// Prüfen, ob mindestens ein Eintrag eine ausgefüllte IBAN hat
		const hasValidIBAN = bankdaten.some((eintrag: any) => {
			const iban = get(eintrag, 'Bankdaten_IBAN', '');
			return iban && iban.trim().length > 0;
		});

		// Button anzeigen, wenn KEINE gültige IBAN vorhanden ist
		return !hasValidIBAN;
	}, [orgaDetails]);

	const showOrganisationButton = useMemo(() => {
		const orgaDatenVollstaendig = isTrue(get(orgaDetails, P.Organisationsprofil_Vollstaendig.path, false));
		return !orgaDatenVollstaendig;
	}, [orgaDetails]);

	return (
		<>
			{(showBankdatenButton || showOrganisationButton) && (
				<MeinBereichPaper title={'Bitte schließen Sie Ihre Registrierung ab:'} titleIcon={<ErrorIcon />} paperMinHeight={'0'}>
					<Stack direction={'row'} spacing={3} justifyContent={'flex-start'} alignItems={'center'}>
						{showOrganisationButton && (
							<Button
								color={'secondary'}
								sx={{ color: '#fff', minHeight: '-webkit-fill-available' }}
								endIcon={<ArrowForwardIosIcon />}
								size={'large'}
								onClick={() => navigate(`${PAGES_URLS.MeinProfil}?activeSideBarButton=organisation`)}
							>
								Organisationsprofil ergänzen
							</Button>
						)}

						{showBankdatenButton && (
							<Button
								color={'secondary'}
								sx={{ color: '#fff', minHeight: '-webkit-fill-available' }}
								endIcon={<ArrowForwardIosIcon />}
								size={'large'}
								onClick={() => navigate(`${PAGES_URLS.MeinProfil}?activeSideBarButton=bankverbindung`)}
							>
								Bankverbindung anlegen
							</Button>
						)}
					</Stack>
				</MeinBereichPaper>
			)}
		</>
	);
};

export default RegisrierungAbschliessen;
